import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="email-otp-setup"
export default class extends Controller {
  static targets = ["sendButton", "verifyStep", "resendButton"]

  connect() {
    this.resendCooldown = 60 // seconds
  }

  async sendTestCode() {
    this.sendButtonTarget.disabled = true
    this.sendButtonTarget.innerHTML = `
      <svg class="animate-spin -ml-1 mr-3 h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
        <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
        <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
      </svg>
      Sending...
    `

    try {
      const response = await fetch('/mfa/send_test_otp', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': document.querySelector('[name="csrf-token"]').content
        },
        body: JSON.stringify({})
      })

      if (!response.ok) {
        throw new Error(`HTTP ${response.status}: ${response.statusText}`)
      }

      const data = await response.json()

      if (data.success) {
        this.showVerifyStep()
        this.showSuccessMessage('Test code sent! Check your email.')
      } else {
        this.showErrorMessage(data.error || 'Failed to send test code')
        this.resetSendButton()
      }
    } catch (error) {
      console.error('Send test code error:', error)
      this.showErrorMessage(`Network error: ${error.message}`)
      this.resetSendButton()
    }
  }

  async resendCode() {
    this.startResendCooldown()
    
    try {
      const response = await fetch('/mfa/send_test_otp', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': document.querySelector('[name="csrf-token"]').content
        },
        body: JSON.stringify({})
      })

      if (!response.ok) {
        throw new Error(`HTTP ${response.status}: ${response.statusText}`)
      }

      const data = await response.json()

      if (data.success) {
        this.showSuccessMessage('New code sent!')
      } else {
        this.showErrorMessage(data.error || 'Failed to resend code')
      }
    } catch (error) {
      console.error('Resend code error:', error)
      this.showErrorMessage(`Network error: ${error.message}`)
    }
  }

  showVerifyStep() {
    this.verifyStepTarget.classList.remove('hidden')
    this.sendButtonTarget.closest('#test-step').classList.add('hidden')
  }

  resetSendButton() {
    this.sendButtonTarget.disabled = false
    this.sendButtonTarget.innerHTML = `
      <svg class="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 19l9 2-9-18-9 18 9-2zm0 0v-8"/>
      </svg>
      Send Test Code
    `
  }

  startResendCooldown() {
    let countdown = this.resendCooldown
    this.resendButtonTarget.disabled = true
    
    const updateButton = () => {
      this.resendButtonTarget.textContent = `Resend in ${countdown}s`
      countdown--
      
      if (countdown < 0) {
        this.resendButtonTarget.disabled = false
        this.resendButtonTarget.textContent = "Didn't receive the code? Resend"
      } else {
        setTimeout(updateButton, 1000)
      }
    }
    
    updateButton()
  }

  showSuccessMessage(message) {
    this.showMessage(message, 'success')
  }

  showErrorMessage(message) {
    this.showMessage(message, 'error')
  }

  showMessage(message, type) {
    // Remove existing messages
    const existingMessages = this.element.querySelectorAll('.alert-message')
    existingMessages.forEach(msg => msg.remove())

    const alertClass = type === 'success' 
      ? 'bg-green-50 border-green-200 text-green-800' 
      : 'bg-red-50 border-red-200 text-red-800'

    const alert = document.createElement('div')
    alert.className = `alert-message p-3 mb-4 border rounded-md ${alertClass}`
    alert.textContent = message

    // Try to find the best container for the message
    const container = this.element.querySelector('.bg-white') || 
                     this.element.querySelector('form') || 
                     this.element
    
    container.prepend(alert)

    // Auto-remove success messages after 5 seconds
    if (type === 'success') {
      setTimeout(() => alert.remove(), 5000)
    }
  }
}
